<template>
  <v-row @click="detail()">
    <v-col cols="1" class="flex-grow-1 flex-shrink-0" style="min-width: 139px; min-height:115px; box-sizing: border-box;">
        <v-img v-if="item.image_url" :src="item.image_url" lazy-src="@/assets/nophoto.png" class="rounded elevation-2" width="115" height="115">
        <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
            </v-row>
        </template>
            <div class="newribbon" v-if="item.new_flg">
                <span>NEW</span>
            </div>
            <v-chip x-small dark color="#9D9D9D" class="viewflg_label" v-if="item.read_flg == 0">未読</v-chip>
        </v-img>
        <v-img v-else src="@/assets/notification/noimg@2x.png" lazy-src="@/assets/nophoto.png" class="rounded elevation-2" width="115" height="115">
            <div class="newribbon" v-if="item.new_flg">
                <span>NEW</span>
            </div>
            <v-chip x-small dark color="#9D9D9D" class="viewflg_label" v-if="item.read_flg == 0">未読</v-chip>
        </v-img>
    </v-col>
    <v-col class="flex-grow-1 flex-shrink-1 pl-1">
        <v-chip outlined x-small class="mb-2" v-if="item.chipsname" style="color:#9D9D9D; border-color: #9D9D9D;">{{item.chipsname}}</v-chip>
        <h1 class="subtitle-2 font-weight-bold nl2br mb-1" style="line-height: 18px;">{{item.title}}</h1>
        <p class="overline mb-0" v-if="item.start_date || item.end_date">有効期限：<span v-if="item.start_date">{{item.start_date}}</span>〜<span v-if="item.end_date">{{item.end_date}}</span></p>
        <p class="overline mb-0" v-if="item.shop_name">対象店舗：{{item.shop_name}}</p>
    </v-col>
  </v-row>
</template>

<script>
export default {
    props: {
        router_param: {
            type: String,
            required: true
        },
        item: {
            type: Object,
            required: true
        },
        fixed: {
            type: Boolean,
            default: false
        }
    },
    methods: {
      async detail() {
        // push既読処理
        var res = null;
        // GET パラメータを取得
        this.getUrlParam()
        //createdで、localstrageから全ての保存情報を取得しinitに格納
        this.init = this.storageGet('*')
        this.create_date = this.init.create_date;
        this.push_date = this.init.push_date;
        this.shop_name = this.init.shop_name;
        var params = { params: {
          'sid': this.init.sid,
          'service_cd': this.init.service_cd,
          'device_uid': this.init.device_uid,
          'device_id': this.init.device_id,
          'os': this.init.os,
          'key': this.init.key,
          'id': this.item.id,
        }};
        if (this.item.contents_type == 1) {// お知らせ
            res = await this.apiCall('/user/notification/detail', params, 'get');
            if (!res) return false;
            this.routerBindTo({name: 'notification_detail', query: {
              id: this.item.content_id,
              // NEW_DEV-1437 cyber start
              push_id: this.item.id,
              contents_type: this.item.contents_type,
              create_date: this.item.push_date,
              shop_name: this.item.shop_name,
              //NEW_DEV-1783 cyber start
              push_date: this.item.push_date,
              //NEW_DEV-1783 cyber end
            }});
        } else if (this.item.contents_type == 2) { // クーポン
            res = await this.apiCall('/user/notification/detail', params, 'get');
            if (!res) return false;
            this.routerBindTo({name: 'coupon_detail', query: {
              id: this.item.content_id,
              push_id: this.item.id,
              create_date: this.item.push_date,
            }});
        } else if (this.item.contents_type == 7) { // チケット当選
            res = await this.apiCall('/user/notification/detail', params, 'get');
            if (!res) return false;
            this.routerBindTo({name: 'digital_buy', query: {
              ticket_id: this.item.content_id,
              history_id: res.data.ticket_history_id,
              win: true,
            }});
        } else {
          this.routerBindTo({name: 'notification_detail', query: {
            id: this.item.id,
            push_id: this.item.id,
            // NEW_DEV-1437 cyber end
            contents_type: this.item.contents_type,
            create_date: this.item.create_date,
            push_date: this.item.push_date,
            shop_name: this.item.shop_name
          }});
        }
      },
      nextRoute(destination, feature_id, screen_id, transition_type, page_title) {
        if (!this.screenTransition({
          destination: destination,
          feature_id: feature_id,
          screen_id: screen_id,
          transition_type: transition_type,
          page_title: page_title,
        })) {
          this.loading = false;
          // 遷移失敗・遷移情報が変な時もエラー表示があった方が良い？
          this.callDialog(
            "遷移エラー",
            "遷移情報が不正です。再度アクセスして下さい。",
            2
          );
      }
    }
  }
}
</script>

<style scoped>
.rounded {
    border-radius: 10px;
}
.viewflg_label {
    position: absolute;
    left: 5px;
    bottom: 5px;
}
.overline {
  line-height: inherit !important;
  text-transform: none !important;
}
</style>
